import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const KlappeRinne = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bilder laden
  const pathZu = require("../../images/controls/Klappe Rinne/KlappeZu.png");
  const pathOffen = require("../../images/controls/Klappe Rinne/KlappeOffen.png");
  const pathEinschVerz = require("../../images/controls/Klappe Rinne/KlappeRinneEinschVerz.gif");
  const pathAusschVerz = require("../../images/controls/Klappe Rinne/KlappeRinneAusschVerz.gif");
  const pathSto = require("../../images/controls/Klappe Rinne/KlappeRinneSto.gif");

  let imagePath = pathZu;
  if (isFinite(idx)) {
    switch (idx) {
      case 0:
        imagePath = pathZu;
        break;
      case 1:
        imagePath = pathOffen;
        break;
      case 2:
        imagePath = pathEinschVerz;
        break;
      case 3:
        imagePath = pathAusschVerz;
        break;
      case 4:
        imagePath = pathSto;
        break;
    }
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
      src={imagePath}
    />
  );
});

export default KlappeRinne;
